export default __webpack_public_path__ + "static/media/slider1.385b3bb6.png";